module.exports = __webpack_public_path__ + "static/media/NXTGEN.7c179458.jpg";